module.exports = __webpack_public_path__ + "img/grey_002.ca8c7692.png";